/**
* This is the app layout (left menu, content area and footer)
*
* Created by Paul on 1/5/19
*/

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import cx from 'classnames'
import { withRouter } from 'react-router-dom'


// action import
import { ActionCreator } from '../../actions/'

// routes import
// NOTE: all components that uses `Routes` need to be wrapped with `withRouter()`
import Routes from '../../routes'

// components
import TopBar from '../../components/TopBar/'
import Overlay from '../../components/Overlay/'
import LeftMenu from '../../components/LeftMenu/'
import RightMenu from '../../components/RightMenu/'
import Footer from '../../components/Footer/'

import Hamburger from '../../assets/svg/hamburger.svg'

// style import
import './style.scss'

class MemberArea extends Component {

    componentWillMount() {
        const { getProfileData, getFundsSummaryData } = this.props

        getProfileData()
        getFundsSummaryData()
    }

    componentDidMount() {
        const { breakPointObj, setOpenRightMenu } = this.props

        // set the right menu to open for desktop view
        if(breakPointObj.greaterThan.medium)
            setOpenRightMenu(true)
    }

    _onHamburgerClick() {
        const { setOpenLeftMenu, openLeftMenu } = this.props

        // close/open the left menu
        openLeftMenu ? setOpenLeftMenu(false) : setOpenLeftMenu(true)
    }

    render() {

        const { breakPointObj, profile } = this.props
        
        // member-area classes based on the truthy value 'openRightMenu'
        const dynClass = cx('member-area')



        return (
            <div className={dynClass}>

                {/* body element that contains the overlay, menus & footer */}
                <div className="body-container">

                    {/* overlay component (only show on tablet and mobile)*/}
                    {
                        (breakPointObj.lessThan.large && <Overlay />)
                    }

                    { breakPointObj.lessThan.large &&
                        <div className="hamburger-container" onClick={::this._onHamburgerClick}>
                            <img
                                src={Hamburger}
                                className="hamburger"
                                alt="Mobile view hamburger icon"
                                />
                        </div>
                    }

                    {/* routing happens only in the main area */}
                    <div className="main"><Routes/></div>

                    {/* left menu component */}
                    <LeftMenu />

                    {/* footer component (only show on tablet)*/}
                    {
                        (breakPointObj.lessThan.large && <Footer />)
                    }

                </div>

            </div>
        )
    }
}

// define the prop types
MemberArea.propTypes = {
    breakPointObj: PropTypes.object,
    getProfileData: PropTypes.func.isRequired,
    profile: PropTypes.object,
}

// pull props to this container
const mapStateToProps = (state) => {
    return {
        breakPointObj: state.browser,
        openRightMenu: state.componentState.openRightMenu,
        profile: state.profileState.data,
        openLeftMenu: state.componentState.openLeftMenu
    }
}

// pull all required action creators into this container
const mapDispatchToProps = (dispatch) => {
    const action = bindActionCreators(ActionCreator, dispatch)
    return {
        setOpenRightMenu: action.setOpenRightMenu,
        getProfileData: action.getProfileData,
        setOpenLeftMenu: action.setOpenLeftMenu,
        getFundsSummaryData: action.getFundsSummaryData,
    }
}
/*
    you can get access to the history object's properties and the closest
    <Route>'s match via the `withRouter` higher-order component. `withRouter`
    will pass updated match, location, and history props to the wrapped
    component whenever it renders.
*/
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MemberArea))



// WEBPACK FOOTER //
// ./src/components/MemberArea/index.js